import { Action, State, StateContext } from '@ngxs/store';
import {
  FetchCustomsCityAbiStateModel,
  FetchCustomsCityDraftStateModel,
  FetchFullmanFileStateModel,
} from '../fullman-upload.model';
import {
  FetchCustomsCityAbiData,
  FetchCustomsCityDraftData,
  FetchFullmanFileData,
  ResetCustomsCityAbiList,
  ResetCustomsCityDraftList,
  ResetFullmanFileList,
} from './fullman-upload.action';
import { updateState } from 'src/app/shared/utility/store.utility';
import { Injectable } from '@angular/core';

@Injectable()
@State<FetchFullmanFileStateModel>({
  name: 'fullmanFileList',
  defaults: {
    fullman: [],
    totalData: 0,
  },
})
export class FullmanFileListState {
  @Action(FetchFullmanFileData)
  FetchFullmanFileData(
    ctx: StateContext<FetchFullmanFileStateModel>,
    action: FetchFullmanFileData
  ) {
    const payload = action.payload;
    if (payload.data?.fullman && payload.data?.totalRecords) {
      updateState(ctx, {
        fullman: payload.data.fullman,
        totalData: payload.data.totalRecords,
      });
    } else {
      updateState(ctx, {
        fullman: [],
        totalData: 0,
      });
    }
  }

  @Action(ResetFullmanFileList)
  ResetFullmanFileList(ctx: StateContext<FetchFullmanFileStateModel>) {
    updateState(ctx, {
      fullman: [],
      totalData: 0,
    });
  }
}

@Injectable()
@State<FetchCustomsCityDraftStateModel>({
  name: 'customsCityDraftState',
  defaults: {
    draftRows: [],
    totalRecords: 0,
  },
})
export class CustomsCityDraftState {
  @Action(FetchCustomsCityDraftData)
  FetchCustomsCityDraftData(
    ctx: StateContext<FetchCustomsCityDraftStateModel>,
    action: FetchCustomsCityDraftData
  ) {
    const payload = action.payload;
    const draftData = payload.data;
    if (draftData && Array.isArray(draftData.customsCityDraftData)) {
      updateState(ctx, {
        draftRows: draftData.customsCityDraftData,
        totalRecords: draftData.totalRecords ?? 0,
      });
    } else {
      updateState(ctx, {
        draftRows: [],
        totalRecords: 0,
      });
    }
  }

  @Action(ResetCustomsCityDraftList)
  ResetCustomsCityDraftList(ctx: StateContext<FetchCustomsCityDraftStateModel>) {
    updateState(ctx, {
      draftRows: [],
      totalRecords: 0,
    });
  }
}

@Injectable()
@State<FetchCustomsCityAbiStateModel>({
  name: 'customsCityAbiState',
  defaults: {
    abiRows: [],
    totalRecords: 0,
  },
})
export class CustomsCityAbiState {
  @Action(FetchCustomsCityAbiData)
  FetchCustomsCityAbiData(
    ctx: StateContext<FetchCustomsCityAbiStateModel>,
    action: FetchCustomsCityAbiData
  ) {
    const payload = action.payload;
    const abiData = payload.data;
    if (abiData && Array.isArray(abiData.customsCityAbiData)) {
      updateState(ctx, {
        abiRows: abiData.customsCityAbiData,
        totalRecords: abiData.totalRecords ?? 0,
      });
    } else {
      updateState(ctx, {
        abiRows: [],
        totalRecords: 0,
      });
    }
  }

  @Action(ResetCustomsCityAbiList)
  ResetCustomsCityAbiList(ctx: StateContext<FetchCustomsCityAbiStateModel>) {
    updateState(ctx, {
      abiRows: [],
      totalRecords: 0,
    });
  }
}

/* LEGACY CBP NgXS — kept in git history via fullman-upload.action.ts comments. Rollback: restore CbpRequestState / CbpResponseState classes and store.module registration. */
